export const mailtoBuilder = (searchCategories,url) => {

  let mailto = 'mailto:hello@envisionsaintjohn.com?subject=Down by the Bay Your Way Entry&body=*Don’t forget to include your first and last name as part of your entry!%0D%0A%0D%0A%0D%0A'
  mailto += "First name: %0D%0A%0D%0A"
  mailto += "Last name: %0D%0A%0D%0A"
  mailto += "Location: %0D%0A%0D%0A"
  mailto += "🔗 Full itinerary: " + encodeURIComponent(url) + "%0D%0A%0D%0A%0D%0A"
  mailto += "Here's your top 3 for each category:%0D%0A%0D%0A%0D%0A"



  searchCategories.forEach((result, index) => {
    let catTitle = result.title.replaceAll("&", "and")
    let catCounter = 0
    mailto += '➡️ ' +catTitle + '%0D%0A%0D%0A'
    result.results.forEach((item, subindex) => {
      if (catCounter < 3) {
        let address = item.address.replace(/(<([^>]+)>)/gi, "")
        let title = item.title.replaceAll("&", "and")
        address = address.replace(/\n/gi, " ")
        address = address.replace(/ +(?= )/g,'');
        address = address.replaceAll("&", "")
        mailto += title + '%0D%0A'
        mailto += address + '%0D%0A%0D%0A'
        catCounter++
      }
    })
  })

  return mailto;

}
